module.exports = __webpack_public_path__ + "media/src/img/logo-0e2c7beae0c2623e816c5d80bd56cc04.svg";